<div class="quote-parent-container">

    <div
        *ngIf="jobcard && (jobcard?.quote?.lineItems?.length || 0) === 0 && (jobcard?.selectedServiceTypes?.length || 0) === 0 && !jobcard.id && !isPhoneView">

        <div class="empty-state-container">
            <img src="../../../../../assets/images/mountain.png" alt="Empty State" class="empty-state-image" />

            <div class="empty-state-text">
                {{ 'bikeshop.workshop.jobcard.getting_started_message' | translate }}
            </div>
        </div>

    </div>

    <div
        *ngIf="jobcard?.id || isPhoneView || (jobcard && (jobcard.quote && jobcard.quote.lineItems && jobcard.quote.lineItems.length > 0) || (jobcard.selectedServiceTypes && jobcard.selectedServiceTypes.length > 0))">

        <div class="quote-banner" *ngIf="jobcard.selectedItem?.id">
            <div class="item-details-container">
                <span class="project529"
                    pTooltip="{{(jobcard.project529?.status == 'Stolen' ? 'bikeshop.modal.update_job_card.project_529.stolen_message' : jobcard.project529?.status == 'Registered' ? 'bikeshop.modal.update_job_card.project_529.registered_message' : 'bikeshop.modal.update_job_card.project_529.not_registered_message') | translate}}"
                    [ngStyle]="{'cursor':jobcard.project529?.status != 'Registered' ? 'pointer' : 'default'}"
                    *ngIf="(jobcard.selectedItem.serialNo || jobcard.selectedItem.serialNumber) && jobcard.project529 && jobcard.project529?.status"
                    (click)="project529Action(jobcard.project529, $event)">
                    <!-- <img src="./assets/project529/logo_2.png" > -->
                    <div class="common stolen1" *ngIf="jobcard.project529?.status == 'Stolen'"><daz-icon
                            name="light_emergency_on_duo" [size]="'18px'" color="#f8312f"></daz-icon></div>
                    <div class="common registered1" *ngIf="jobcard.project529?.status == 'Registered'"><daz-icon
                            name="shield_check_duo" [size]="'18px'" color="#00d26a"></daz-icon></div>
                    <div class="common not-registered1" *ngIf="jobcard.project529?.status == 'Not Registered'">
                        <daz-icon name="shield_slash_duo" [size]="'18px'" color="#ff8400"></daz-icon>
                    </div>
                </span>

                <div class="item-details" (click)="openItemDetails()">
                    <div>{{jobcard.selectedItem.manufacturer}} {{jobcard.selectedItem.model}}</div>
                    <div class="item-details-sub">
                        <div *ngIf="jobcard.selectedItem?.serialNo?.trim() || jobcard.selectedItem?.serialNumber?.trim()"
                            class="serial-no">
                            {{jobcard.selectedItem.serialNo || jobcard.selectedItem.serialNumber}}
                        </div>
                        <div *ngIf="jobcard.selectedItem?.colour?.trim()">{{jobcard.selectedItem.colour}}</div>
                        <div *ngIf="jobcard.selectedItem?.modelYear > 0">{{jobcard.selectedItem.modelYear}}</div>
                    </div>
                </div>
            </div>
            <div class="quote-action-items" *ngIf="jobcard.id">
                <div class="quote-options" *ngIf="partnerData.AllowMultipleQuoteOptions && !loadingQuoteOptions">
                    <hub-button [icon]="invoiceOptions.length > 0 ? 'pencil' : 'plus-alt'" [size]="'md'"
                        [style]="'outline'"
                        [text]="(invoiceOptions.length > 0 ? 'bikeshop.modal.update_job_card.update_quote_options' : 'bikeshop.modal.update_job_card.quote_options') | translate"
                        (buttonClick)="openQuoteOptions()"></hub-button>
                    <!-- <span *ngIf="invoiceOptions.length > 0 && getQuoteOptionsStatus() > 0"
                        [ngClass]="{ 'sent' : getQuoteOptionsStatus() === 1 , 'seen' : getQuoteOptionsStatus() === 2, 'approved' : getQuoteOptionsStatus() === 10, 'rejected' : getQuoteOptionsStatus() === 9 }"></span> -->
                </div>
            </div>
        </div>

        <div *ngIf="(jobcard.id || isPhoneView) && jobcard?.quote?.statusID != 10" class="quote-search-container">
            <app-workshop-jobcard-quote-search-area [jobcard]="jobcard" [serviceTypes]="serviceTypes"
                (jobcardChange)="onJobCardChange($event)" [hideSearchSummary]="true"
                [productSKUServiceTypeCollection]="productSKUServiceTypeCollection"></app-workshop-jobcard-quote-search-area>
        </div>

        <div class="quote-container">
            <div class="quote-header quote-button-row">
                <div class="button-container">
                <ng-container *ngIf="canAddCoupon">
                    <div *ngIf="!this.jobcard.quote.couponCode">
                        <hub-button *ngIf="canAddCoupon" [icon]="'plus'" [size]="'sm'" [style]="'borderless'"
                            text="{{ 'bikeshop.coupons.add_coupon' | translate }}"
                            [disabled]="jobcard.quote?.statusID === 10" (buttonClick)="addCoupon()"></hub-button>
                        <hub-button *ngIf="!canAddCoupon" [icon]="'plus'" [size]="'sm'" [style]="'borderless'"
                            [disabled]="!canAddCoupon || jobcard.quote?.statusID === 10"
                            pTooltip="{{ 'bikeshop.workshop.jobcard.quote.discounts_not_enabled' | translate }}"
                            tooltipPosition="bottom" text="{{ 'bikeshop.coupons.add_coupon' | translate }}"
                            (buttonClick)="addCoupon()"></hub-button>
                    </div>
                    <div *ngIf="this.jobcard.quote.couponCode" class="coupon-applied">
                        <span class="coupon-code">{{jobcard.quote.couponCode}}</span>
                        <span>({{jobcard.quote.couponDiscountType !== 'PERCENT' ? currencySymbol :
                            ''}}{{jobcard.quote.couponDiscount}}{{jobcard.quote.couponDiscountType === 'PERCENT' ? '%' :
                            ''}})</span>
                        <span *ngIf="jobcard.quote?.statusID !== 10" class="action" (click)="removeCoupon()"><daz-icon
                                [name]="'trash'" [size]="'20px'" [color]="'#ffffff'"></daz-icon></span>
                    </div>
                   
                </ng-container>
                <ng-container *ngIf="needsSpecialOrder() && jobcard.quote?.statusID !== 10">
                     <hub-button [icon]="'plus'" [size]="'sm'" [style]="'borderless'"
                        *ngIf="needsSpecialOrder() && jobcard.quote?.statusID !== 10"
                        text="{{ 'bikeshop.workshop.jobcard.quote.special_order' | translate }}"
                        (buttonClick)="createSpecialOrder()">
                    </hub-button>
                </ng-container>
                 </div>
            </div>

            <div class="quote-line-items-container">
                <div class="quote-section" *ngIf="sectionLines(true).length > 0">
                    <div class="quote-section-header">
                        <div class="quote-header-text">{{ 'bikeshop.workshop.jobcard.labour' | translate }}</div>
                        <div class="quote-section-amount">{{ getSectionAmount(sectionLines(true)) | currency : currencySymbol }}</div>
                    </div>
                    <ng-container *ngFor="let lineItem of sectionLines(true)">
                        <ng-container *ngTemplateOutlet="lineRow; context: { $implicit: lineItem }"></ng-container>
                    </ng-container>
                </div>

                <div class="quote-section" *ngIf="sectionLines(false).length > 0">
                    <div class="quote-section-header">
                        <div class="quote-header-text">{{ 'bikeshop.workshop.jobcard.parts_and_materials' | translate }}</div>
                        <div class="quote-section-amount">{{ getSectionAmount(sectionLines(false)) | currency : currencySymbol }}</div>
                    </div>
                    <ng-container *ngFor="let lineItem of sectionLines(false)">
                        <ng-container *ngTemplateOutlet="lineRow; context: { $implicit: lineItem }"></ng-container>
                    </ng-container>
                </div>

                <ng-template #lineRow let-lineItem>
                <div class="quote-line-item"
                    (click)="jobcard.quote?.statusID !== 10 ? editLineItem(lineItem) : null"
                    [ngClass]="{'archived-product': lineItem.FoundInPOS === false}">

                    <div class="pos-sync-status" *ngIf="jobcard.quote.id && jobcard.quote.externalKey">
                        <div *ngIf="lineItem.ExternalKey"
                            class="{{useWorkOrdersForWorkshop && jobcard.quote.workOrderID && (lineItem.HasBeenUpdated === true || lineItem.HasBeenUpdated === 'true') ? 'partially-synced' : 'synced'}}">
                            <daz-icon [name]="'synced'" [size]="'20px'" [color]="'#060931'"
                                pTooltip="{{ 'bikeshop.modal.update_job_card.quote.item-sent-to-pos' | translate }}"></daz-icon>
                        </div>
                        <div *ngIf="!lineItem.ExternalKey" class="not-synced">
                            <daz-icon [name]="'not-synced'" [size]="'20px'" [color]="'#060931'"
                                pTooltip="{{ 'bikeshop.modal.update_job_card.quote.item-not-sent-to-pos' | translate }}"></daz-icon>
                        </div>
                    </div>
                    <div class="quote-approval-status" *ngIf="jobcard.quote.id && hasApprovedLineItems()">
                        <div *ngIf="lineItem.Approved === 1" class="approved">
                            <daz-icon [name]="'check'" [size]="'20px'" [color]="'#060931'"
                                pTooltip="{{ 'bikeshop.modal.update_job_card.approved' | translate }}"></daz-icon>
                        </div>
                        <div *ngIf="lineItem.Approved === 2" class="rejected">
                            <daz-icon [name]="'circle-exclamation'" [size]="'20px'" [color]="'#060931'"
                                pTooltip="{{ 'bikeshop.modal.update_job_card.rejected' | translate }}"></daz-icon>
                        </div>
                    </div>

                    <div class="quote-line-quantity">
                        {{ lineItem.Quantity }}x
                    </div>
                    <div class="quote-line-name">
                        <div>{{ lineItem.Name }}</div>
                        <div>{{ lineItem.SKU }}
                            <span *ngIf="lineItem.LinkedServiceTypes && lineItem.LinkedServiceTypes.length > 0">
                                |{{getSKUDuration(lineItem)}}{{( getSKUDuration(lineItem).toFixed(0) === 1 ?
                                'general.hr':'general.hrs' ) | translate}}</span>
                            <span *ngIf="lineItem.StockOnHand && lineItem.StockOnHand > 0"> | {{lineItem.StockOnHand}}
                                {{'bikeshop.modal.update_job_card.quote.qty' | translate}}</span>
                            <span *ngIf="lineItem.OutOfStock && lineItem.SpecialOrderStatus === null"
                                class="out-of-stock"> {{'bikeshop.workshop.jobcard.quote.no_stock' | translate}}</span>
                            <span *ngIf="lineItem.SpecialOrderStatus === 'Not Ordered'" class="not-ordered">
                                {{'bikeshop.workshop.jobcard.quote.not_ordered' | translate}}</span>
                            <span *ngIf="lineItem.SpecialOrderStatus === 'Ordered'" class="ordered">
                                {{'bikeshop.workshop.jobcard.quote.ordered' | translate}}</span>
                            <span
                                *ngIf="lineItem.SpecialOrderStatus && lineItem.SpecialOrderStatus.indexOf('Ready') > -1"
                                class="arrived"> {{'bikeshop.workshop.jobcard.quote.arrived' | translate}}</span>
                            <!-- {{lineItem.ID || 'N/A'}} {{lineItem.InternalProductID}} {{lineItem.SKU}} -->
                        </div>
                    </div>
                    <div class="quote-line-price">
                        <div>{{ (vatInclusive ? lineItem.UnitPrice_IncludingTax : lineItem.UnitPrice) | currency:
                            currencySymbol}}</div>
                        <div *ngIf="lineItem.Discount && lineItem.Discount > 0" class="discount-lineitem">
                            -{{((jobcard.quote.couponDiscountType === 'PERCENT' ? lineItem.Quantity : 1 ) *
                            lineItem.Discount).toFixed(2) | currency: currencySymbol}}
                            <!-- <span *ngIf="jobcard.quote.couponDiscountType === 'PERCENT' && !lineItem.DiscountType">({{jobcard.quote.couponDiscount}}%)</span>
                            <span *ngIf="lineItem.DiscountType === 'PERCENT'">({{lineItem.DiscountPercent}}%)</span> -->
                            <span
                                *ngIf="lineItem.DiscountID > 0 && getLSDiscountPercentage(lineItem.DiscountID)">({{getLSDiscountPercentage(lineItem.DiscountID)}}%)</span>
                        </div>
                    </div>
                    <div class="quote-line-note">
                        <hub-button [icon]="'sticky-note'" [size]="'sm'" [style]="'outline'"
                            [disabled]="loadingQuote || jobcard.quote?.statusID === 10"
                            pTooltip="{{ lineItem.LineItemNote && lineItem.LineItemNote.length > 0 ? lineItem.LineItemNote : '' }}"
                            (buttonClick)="addLineItemNote(lineItem, $event)"></hub-button>
                        <span *ngIf="lineItem.LineItemNote && lineItem.LineItemNote.length > 0">1</span>
                    </div>
                    <!-- <div class="quote-line-actions">
                        <hub-button [icon]="'dots-vertical'" [size]="'sm'" [style]="'outline'" [disabled]="loadingQuote"
                            (buttonClick)="lineItem.showActions = !lineItem.showActions"></hub-button>
                        <div *ngIf="lineItem.showActions" class="quote-line-actions-dropdown">
                            <div (click)="editLineItem(lineItem)">
                                <daz-icon [name]="'pencil'" [size]="'16px'" [color]="'#060931'"></daz-icon>
                                <span>{{ 'general.edit' | translate }}</span>
                            </div>
                            <div (click)="removeLineItem(lineItem)">
                                <daz-icon [name]="'trash'" [size]="'16px'" [color]="'#060931'"></daz-icon>
                                <span>{{ 'bikeshop.general.delete' | translate }}</span>
                            </div>
                        </div>
                    </div> -->
                    <div class="quote-line-actions">
                        <hub-button [icon]="'trash'" [size]="'sm'" [style]="'outline'"
                            [disabled]="loadingQuote || jobcard.quote?.statusID === 10"
                            (buttonClick)="removeLineItem(lineItem, $event)"></hub-button>
                    </div>

                </div>
                </ng-template>
                <div class="margin-top-24"></div>
                <div class="tax-total" *ngIf="!vatInclusive">
                    <div>{{ 'bikeshop.modal.update_job_card.quote.sub-total' | translate }}</div>
                    <div>{{ jobcard.quote.subtotal | currency : currencySymbol }}</div>
                </div>
                <div class="tax-total" *ngIf="helpersService.showTaxRow(jobcard.quote.tax, partnerData)">
                    <div>{{ 'bikeshop.modal.update_job_card.quote.vat' | translate }}</div>
                    <div>{{ jobcard.quote.tax | currency : currencySymbol }}</div>
                </div>
                <div class="total">
                    <div>{{ 'bikeshop.modal.update_job_card.quote.total' | translate }}</div>
                    <div><span
                            [ngClass]="{'error' : !jobcard.selectedServiceTypes || jobcard.selectedServiceTypes.length === 0}">{{getDurationFormatted(this.jobcard.serviceDuration
                            || 0)}}</span> |
                        {{ jobcard.quote.total | currency : currencySymbol }}<span class="original-total"
                            *ngIf="jobcard.quote.totalWithoutDiscount != jobcard.quote.total">{{jobcard.quote.totalWithoutDiscount
                            | currency : currencySymbol}}</span></div>
                </div>
            </div>
        </div>
        <!-- <div class="quote-container margin-top-16" *ngIf="jobcard.selectedServiceTypes && jobcard.selectedServiceTypes.length > 0">
            <div class="quote-header">
                <div class="quote-header-text">{{ 'bikeshop.menu.service_types' | translate }}</div>
            </div>
            <div class="service-type-container">
                <div class="service-type-item" *ngFor="let serviceType of jobcard.selectedServiceTypes">
                    <div class="service-type-name">
                        {{ serviceType.serviceType }}
                    </div>
                    <span class="action" (click)="removeServiceType(serviceType)"><daz-icon [name]="'trash'"
                            [size]="'20px'" [color]="'#ffffff'"></daz-icon></span>
                </div>
            </div>
        </div> -->

    </div>
</div>

<div *ngIf="jobcard.thirdPartyID > 0 && !jobcard.quote.askForApproval" class="send-third-party">
    <div>{{ "bikeshop.modal.update_job_card.quote.send_quote_to_third_party_only"
        | translate }}</div>
    <hub-checkbox [(ngModel)]="sendToThirdPartyOnly"></hub-checkbox>
</div>

<div class="quote-footer" *ngIf="jobcard && jobcard.id">
    <div class="quote-footer-actions">

        <hub-button [size]="'xl'" [style]="'outline'"
            [disabled]="jobcard.quote.askForApproval || sendingApproval || jobcard.quote.statusID == 10"
            [loading]="sendingApproval" text="{{ 'bikeshop.workshop.jobcard.quote.send_to_customer' | translate }}"
            (buttonClick)="sendQuoteToCustomer()"></hub-button>

        <div>
            <hub-button [size]="'xl'" [style]="'outline'"
                *ngIf="!useWorkOrdersForWorkshop && jobcard.quote.externalKey && jobcard.quote.externalKey != '0'  && (getPOSName() === 'Lightspeed R' || getPOSName() === 'Xero' || getPOSName() === 'Citrus Lime')"
                class="p-button-raised full-width alternate lock-exempt" (buttonClick)="openPOSURL()"
                text="{{'bikeshop.modal.update_job_card.quote.view_quote_in'| translate}} {{ getPOSName() }}"></hub-button>
            <hub-button [size]="'xl'" [style]="'outline'" *ngIf="useWorkOrdersForWorkshop && jobcard.quote.workOrderID"
                class="p-button-raised full-width alternate lock-exempt" (buttonClick)="openWorkOrderURL()"
                text="{{'bikeshop.workshop.jobcard.view_work_order'| translate}}"></hub-button>
            <hub-button [size]="'xl'" [style]="'outline'"
                *ngIf="jobcard.quote.externalKey && (getPOSName() === 'Shopify')"
                class="p-button-raised full-width alternate lock-exempt"
                text="{{'bikeshop.modal.update_job_card.quote.view_quote_in'| translate}} {{ getPOSName() }}: {{ jobcard.quote.externalRefNo }}"></hub-button>
            <hub-button [size]="'xl'" [style]="'outline'"
                *ngIf="jobcard.quote.externalKey && (partnerData.POSSystemID === 16)"
                class="p-button-raised full-width alternate lock-exempt" (buttonClick)="openPOSURL()"
                text="{{'bikeshop.modal.update_job_card.quote.view_quote_in'| translate}} {{ getPOSName() }}: {{ jobcard.quote.externalRefNo }}"></hub-button>
            <hub-button [size]="'xl'" [style]="'outline'"
                *ngIf="jobcard.quote.synchFeedback && jobcard.quote.synchFeedback !== '' && (partnerData.POSSystemID === 16)"
                class="p-button-raised full-width alternate lock-exempt" (buttonClick)="openPOSURL_SalesOrder()"
                text="Sales order: {{ jobcard.quote.synchFeedback.split('|')[1] }}"></hub-button>
            <hub-button [size]="'xl'" [style]="'outline'"
                *ngIf="jobcard.quote.externalKey && (partnerData.POSSystemID === 16 && partnerData.POSCustomURL != null && partnerData.POSCustomURL.length > 0)"
                class="p-button-raised full-width alternate lock-exempt" (buttonClick)="openPOSURL()"
                text="{{'bikeshop.modal.update_job_card.quote.view_quote_in'| translate}} {{ getPOSName() }}: {{ jobcard.quote.externalRefNo }}"></hub-button>
        </div>

        <hub-button *ngIf="partnerData.POSSystemID === 16 && jobcard.quote.statusID != 10" [size]="'xl'"
            [style]="'secondary'" class="lock-exempt"
            text="{{ 'bikeshop.workshop.jobcard.create_sales_order' | translate }}"
            [disabled]="sendingToPOS || loadingQuote" [loading]="sendingToPOS"
            (buttonClick)="createSalesOrder(true, null)"></hub-button>
        <hub-button *ngIf="!useWorkOrdersForWorkshop && partnerData.POSSystemID > 0 && jobcard.quote.statusID != 10"
            [size]="'xl'" [style]="'secondary'" class="lock-exempt"
            text="{{ (partnerData.POSSystemID === 16 ? 'bikeshop.workshop.jobcard.send_to_pos_invoice' : partnerData.POSSystemID === 22 ? 'bikeshop.modal.update_job_card.quote.button.create_workorder' : 'bikeshop.workshop.jobcard.quote.send_to_pos') | translate }}"
            [disabled]="sendingToPOS || loadingQuote" [loading]="sendingToPOS"
            (buttonClick)="sendQuoteToPOS(true, null)"></hub-button>
        <hub-button *ngIf="useWorkOrdersForWorkshop && jobcard.quote.statusID != 10" [size]="'xl'" [style]="'secondary'"
            class="lock-exempt" text="{{ 'bikeshop.workshop.jobcard.sync_work_order' | translate }}"
            [disabled]="sendingToPOS || loadingQuote" [loading]="sendingToPOS"
            (buttonClick)="sendQuoteToPOS(true, null)"></hub-button>
    </div>
</div>
<div>
    <div class="delay-message" *ngIf="showTakingTooLong && sendingToPOS">
        {{ 'bikeshop.workshop.jobcard.quote.send_to_pos_taking_too_long' | translate }}
    </div>
</div>

<div *ngIf="jobcard.paidWithStripe" class="paid-with-stripe">
    <span class="text">{{ "bikeshop.modal.update_job_card.job_card.customer_paid_with" | translate }}</span>
    <span class="icon fa fa-cc-stripe"></span>
</div>
<div *ngIf="jobcard.paidWithPOS" class="paid-with-pos">
    <span class="text">{{ "bikeshop.modal.update_job_card.job_card.customer_paid_with_pos" | translate }}</span>
</div>

<div *ngIf="jobcard && jobcard.id && !sendingToPOS">
    <app-workshop-jobcard-quote-payments [jobcard]="jobcard"></app-workshop-jobcard-quote-payments>
</div>

<p-toast position="bottom-center" [style]="{ 'z-index': '10000' }" [baseZIndex]="10000" [showTransitionOptions]="'0ms'"
    [hideTransitionOptions]="'0ms'"></p-toast>
